import { useEffect, useMemo } from 'react';

import styled from '@emotion/styled';
import { toastr } from 'react-redux-toastr';
import { useFormik } from 'formik';
import { PageContainer, ServerErrors } from 'components';
import { mapServerError } from 'core';
import { useChangePasswordMutation } from 'store/user/userAPI';

import { Button } from '@britishcouncil/react-solas';
import { MainContainer, NewPasswordField, PasswordField } from '@britishcouncil/react-solas-ors3';
import { useFormFields, useServerErrors } from '@britishcouncil/react-forms';

import { CHANGE_PASSWORD_VALIDATION_SCHEMA } from './validationSchema';

export const ChangePassword = () => {
  const [changePassword, { isLoading, isError, error, isSuccess }] = useChangePasswordMutation();
  const serverErrors = useMemo(() => (!isError ? [] : mapServerError(error)), [error, isError]);

  const formik = useFormik({
    initialValues: {
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
    },
    validationSchema: CHANGE_PASSWORD_VALIDATION_SCHEMA,
    onSubmit: ({ newPassword, currentPassword }) => {
      changePassword({ newPassword, currentPassword });
    },
  });
  const { resetForm } = formik;

  const fields = useFormFields(formik);
  const mainErrors = useServerErrors(formik, serverErrors);

  useEffect(() => {
    if (isSuccess) {
      toastr.success('Success', 'Password changed successfully');
      resetForm();
    }
  }, [isSuccess, resetForm]);

  return (
    <>
      <MainContainer>
        <h1>Change Password</h1>
      </MainContainer>

      <PageContainer>
        <form onSubmit={formik.handleSubmit}>
          <PasswordBox>
            <PasswordField label="Old password" {...fields.currentPassword} />
            <NewPasswordField label="New password" {...fields.newPassword} />
            <PasswordField label="Confirm password" {...fields.confirmPassword} />
          </PasswordBox>
          {!isLoading && <ServerErrors errors={mainErrors} />}
          <Button intent="primary" disabled={isLoading} loading={isLoading}>
            Assign New Password
          </Button>
        </form>
      </PageContainer>
    </>
  );
};

//TODO[GP - future fix]: work around - this styles should be fixed in @britishcouncil/react-solas-ors3 package
const PasswordBox = styled.div`
  .checkbox-inline.gray {
    input {
      box-shadow: 0 0 0 13px #fff !important;
    }
  }
  div.col-md-4 {
    padding: 0 10px;
  }
`;
